import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import LoginDIRForm from './LoginDIRForm/LoginDIRForm';

export const loginDIRSteps: StepWizardStep[] = [
  {
    step: 1,
    component: LoginDIRForm,
    title: 'Connexion <primary>directeur commercial</primary>',
    subtitle: 'Entrez vos identifiants',
  },
];
